import { environment } from 'apps/nagel-cal-disposition/environment/environment';

export function getIsDevelopmentMode() {
    return environment.development;
}

export function getAssetsPath(localeId: string, path: string): string {
    return localeId && !getIsDevelopmentMode()
        ? `../../../${localeId}/assets/${path}`
        : `../assets/${path}`;
}